import axios from "axios"

import { API_URL } from "../../config/appConfig"
import { NewsCategory } from "../../types/NewsCategoryManager"

export const PROPERTY_MANAGER_URL = `${API_URL}/api/PropertyManager`

export const postRecord = (propertyType: string, description: string) => {
  return axios({
    method: "post",
    url: `${PROPERTY_MANAGER_URL}/${propertyType}`,
    params: {
      description
    },
  })
}

export const updateRecord = (propertyType: string, original: string, description: string) => {
  return axios({
    method: "put",
    url: `${PROPERTY_MANAGER_URL}/${propertyType}`,
    params: {
      original,
      description
    },
  })
}

export const getNewsCategory = (issuerId: number, headers: any) => {
  return axios.get(`${PROPERTY_MANAGER_URL}/NewsCategory/${issuerId}`, { headers })
}

export const postNewsCategory = (payload: NewsCategory) => {
  return axios.post(`${PROPERTY_MANAGER_URL}/NewsCategory`, payload)
}

export const putNewsCategory = (payload: NewsCategory) => {
  return axios.put(`${PROPERTY_MANAGER_URL}/NewsCategory`, payload)
}

export const getInstrumentTypes = () => {
  return axios.get(`${PROPERTY_MANAGER_URL}/InstrumentTypeCategory`)
}
